import {useMutation, useQueryClient} from '@tanstack/react-query';

import {activateSportMatches} from '../api';

interface Params {
  categorySlug: string;
  matchIds: string[];
}

export const useActivateSportMatches = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({categorySlug, matchIds}: Params) =>
      activateSportMatches(categorySlug, matchIds),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: ['sportMatches']});
    },
  });
};
